import { RouteComponentProps, useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

type Params = {
  id: string;
  ctgy: string;
};

export function AdminBoardWrite(routeProps: RouteComponentProps) {
  const history = useHistory();
  const { match, location } = routeProps;
  const [boardItem, setBoardItem] = useState<any>();
  // 업로드된 파일
  const [attachedFiles, setAttachedFiles] = useState<any[]>([]);
  // 업로드예정 파일
  const [attachingFiles, setAttachingFiles] = useState<File[]>([]);
  // 삭제예정 파일
  const [removingFiles, setRemovingFiles] = useState<any[]>([]);
  const { id, ctgy } = match.params as Params;

  const [userText, setUserText] = useState(window.localStorage.getItem('name') || '');
  const [title, setTitle] = useState<string>('');
  const [conText, setConText] = useState<string>('');

  const dispatch = useDispatch();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    if (+id > 0) {
      server.getBoardItem(ctgy, id).then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setBoardItem(payload);
          setConText(payload.content);
          setTitle(payload.subject);
          let attacheFiles: any = [];

          for (let i = 1; i <= 5; i++) {
            if (payload[`attach${i}`]) {
              const attacheFile: any = {};
              attacheFile.tag = `attach${i}`;
              attacheFile.filename = payload[`attach${i}`];
              attacheFile.url = payload[`attach${i}Url`];
              attacheFiles = [...attacheFiles, attacheFile];
            }
          }
          setAttachedFiles(attacheFiles);
        }
      });
    }
  }, []);

  const deleteImg = (deleteId: any) => {
    const imgId = attachingFiles?.filter((file) => file.lastModified !== deleteId);
    setAttachingFiles(imgId);
  };

  const attachFileDom = () => {
    return (
      <li>
        <span>첨부파일</span>
        <div className="input-file-container">
          <input
            className="input-files"
            id="file01"
            type="file"
            multiple
            onChange={(e) => {
              if (e.target !== null && e.target.files !== null) {
                if (e.target.files.length > 5 || attachedFiles.length + e.target.files.length > 5) {
                  dispatch(toast.error({ message: '파일은 최대 5개까지만 선택이 가능합니다.' }));
                  return;
                }
                setAttachingFiles(Array.from(e.target.files));
              }
            }}
          />
        </div>
        {/* 서버에 저장된 파일가져오는 로직 */}
        {attachedFiles.map((attachedFile) => (
          <ul className="files" key={attachedFile.tag}>
            <li key={attachedFile.tag}>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a
                href={`${process.env.REACT_APP_API_URL}/public${attachedFile.url}`}
                className="btn-file"
                target="_blank"
              >
                {attachedFile.filename}
              </a>
              <button
                className="btn-delete-attach-file"
                type="button"
                onClick={() => {
                  setAttachedFiles(attachedFiles.filter((file) => file.tag !== attachedFile.tag));
                  setRemovingFiles([...removingFiles, attachedFile]);
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
              </button>
            </li>
          </ul>
        ))}
        {attachingFiles &&
          attachingFiles.map((file) => (
            <ul className="files" key={file.lastModified}>
              <li key={file.lastModified}>
                <button type="button" className="btn-attach-file">
                  {file.name}
                </button>
                <button
                  className="btn-delete-attach-file"
                  type="button"
                  onClick={() => deleteImg(file.lastModified)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  </svg>
                </button>
              </li>
            </ul>
          ))}
      </li>
    );
  };

  const onClickValidation = () => {
    if (title.length <= 0) {
      dispatch(toast.error({ message: '제목을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (conText.length <= 0) {
      dispatch(toast.error({ message: '내용을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (attachedFiles.length + attachingFiles.length - removingFiles.length > 5) {
      dispatch(toast.error({ message: '파일은 5개 까지만 등록이 가능합니다.' }));
      return;
    }
    onClickSave();
  };

  const onClickSave = async () => {
    if (+id > 0) {
      // 글 수정 할 때
      await server
        .updateBoard(ctgy.toString(), id.toString(), {
          subject: title,
          content: conText,
          link: '',
        })
        .then((payload) => {
          history.push(`/admin/board/${ctgy}`);
          return payload;
        })
        .catch((error) => {
          console.log(error);
        });

      if (removingFiles.length > 0) {
        const removeFiles = removingFiles.map((file) => file.tag);
        await server
          .deleteAttaches(ctgy.toString(), id, removeFiles)
          .then((payload) => {
            history.push(`/admin/board/${ctgy}`);
          })
          .catch((error) => {
            console.log('파일 지우기 에러 발생', error);
          });
      }

      if (attachingFiles.length > 0) {
        const uploadFile: any = {};
        attachingFiles.forEach((file, index) => {
          uploadFile[`attach${attachedFiles.length + 1 + index}`] = file;
        });
        await server
          .uploadAttaches(uploadFile, ctgy.toString(), +id)
          .then(() => {
            history.push(`/admin/board/${ctgy}`);
          })
          .catch((error) => console.log('파일 지우기 에러 발생', error));
      }
    } else {
      // 글 수정이 아닐 시
      const newSaveData = await server
        .writeBoard(ctgy.toString(), {
          subject: title,
          content: conText,
          link: '',
          attach1: '',
          attach2: '',
          attach3: '',
          attach4: '',
          attach5: '',
        })
        .then((payload) => {
          history.push(`/admin/board/${ctgy}`);
          return payload;
        })
        .catch((error) => console.log(error));

      if (attachingFiles.length > 0) {
        const newSaveDataId = newSaveData.id;
        const uploadFile: any = {};
        attachingFiles.forEach((file, index) => {
          uploadFile[`attach${attachedFiles.length + 1 + index}`] = file;
        });
        await server
          .uploadAttaches(uploadFile, ctgy.toString(), newSaveDataId)
          .then(() => {
            history.push(`/admin/board/${ctgy}`);
          })
          .catch((error) => console.log(error));
      }
    }
  };

  return (
    <main className="board-add wrapper">
      <div className="title">
        <h1>글 작성</h1>
        <div className="buttons">
          <button
            className="btn-sub"
            type="button"
            onClick={() => {
              routeProps.history.goBack();
            }}
          >
            취소
          </button>
          <button type="button" onClick={() => onClickValidation()}>
            등록
          </button>
        </div>
      </div>
      <div className="content">
        <ul className="inputs">
          <li>
            <span>제목</span>
            <input
              className="full"
              type="text"
              value={title || ''}
              onChange={(e: any) => {
                setTitle(e.target.value);
              }}
            />
          </li>
          <li>
            <span>작성자</span>
            <input type="text" readOnly value={userText || ''} />
          </li>
          {attachFileDom()}
          <li>
            <textarea
              name=""
              id=""
              rows={20}
              value={conText || ''}
              onChange={(e: any) => {
                setConText(e.target.value);
              }}
            />
          </li>
        </ul>
      </div>
    </main>
  );
}
